<div class="od-toolbar">
  <label class="od-input" style="width: 248px; max-width: 100%">
    <od-icon name="search"></od-icon>
    <input type="search" [formControl]="buscar" placeholder="Nombre o RIF" aria-label="Buscar por nombre o RIF" autocomplete="off">
  </label>
  <label class="od-select">
    <span>Estado:</span>
    <select aria-label="Filtrar por estado" (change)="elegirEstado($any($event.target).value)">
      <option *ngFor="let e of estados; trackBy: porValor" [value]="e.valor" [selected]="filtro.estado === e.valor">{{ e.texto }}</option>
    </select>
  </label>
  <span class="od-fin" aria-live="polite" *ngIf="lista$ | async as v">
    <ng-container *ngIf="v.datos">{{ numero(v.datos.total) }} {{ v.datos.total === 1 ? 'comercio' : 'comercios' }}</ng-container>
  </span>
</div>

<ng-container *ngIf="lista$ | async as v">
  <div class="od-alert" role="alert" *ngIf="v.error">
    <od-icon name="alert" [size]="16"></od-icon>
    <div class="od-alert-tx"><b>No se pudo traer la lista de comercios</b><div class="od-muted">{{ v.error }}</div></div>
    <button type="button" class="od-btn" (click)="recargar()"><od-icon name="refresh"></od-icon>Reintentar</button>
  </div>

  <div *ngIf="v.cargando && !v.datos" aria-busy="true" aria-label="Cargando comercios">
    <div class="od-skeleton" style="height: 38px; margin-bottom: 6px"></div>
    <div class="od-skeleton" style="height: 40px; margin-bottom: 6px" *ngFor="let i of esperaSkeleton; trackBy: porIndice"></div>
  </div>

  <ng-container *ngIf="v.datos as pag">
    <div class="od-empty od-card" *ngIf="!pag.items.length">
      <od-icon name="store" [size]="22"></od-icon>
      <b>{{ filtro.q || filtro.estado ? 'Ningún comercio coincide' : 'Todavía no hay comercios anotados' }}</b>
      <span>{{ filtro.q || filtro.estado ? 'Cambia la búsqueda o el filtro.' : 'Aparecen aquí cuando se avisa un comercio a Odoo.' }}</span>
    </div>

    <div class="od-table-wrap" *ngIf="pag.items.length" [style.opacity]="v.cargando ? .6 : 1">
      <table class="od-table">
        <caption style="position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0)">Comercios que se anotan en Odoo.</caption>
        <thead>
          <tr>
            <th scope="col">Comercio</th><th scope="col">RIF</th><th scope="col">Código</th><th scope="col">Tiendas</th>
            <th scope="col">Estado en Odoo</th><th scope="col">Último envío</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let f of pag.items; trackBy: trackFila">
            <td>{{ f.nombre || '—' }}</td>
            <td class="od-mono">{{ f.identificacion | odooRif }}</td>
            <td class="od-mono">{{ f.source_id }}</td>
            <td>{{ f.tiendas }}</td>
            <td>
              <span class="od-badge od-badge-solid" *ngIf="f.estado_ui === 'anotado'"><od-icon name="check"></od-icon>Anotado</span>
              <span class="od-badge" *ngIf="f.estado_ui === 'esperando'"><od-icon name="clock"></od-icon>Esperando envío</span>
              <span class="od-badge od-badge-problem" *ngIf="f.estado_ui === 'problema'"><od-icon name="alert"></od-icon>Con problema</span>
            </td>
            <td>
              <ng-container [ngSwitch]="f.estado_ui">
                <span *ngSwitchCase="'esperando'">Se reintenta {{ f.proximo_reintento | odooHoraSola }}</span>
                <span *ngSwitchCase="'problema'">{{ f.motivo }}</span>
                <span *ngSwitchDefault>{{ f.fe_ultimo_envio | odooFechaCorta }}</span>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="od-toolbar" style="margin-top: 10px" *ngIf="pag.total > pag.limit">
      <span class="od-muted">{{ numero(desde(pag)) }}–{{ numero(hasta(pag)) }} de {{ numero(pag.total) }}</span>
      <span class="od-fin" style="display: inline-flex; gap: 6px">
        <button type="button" class="od-btn od-btn-sm" [disabled]="pag.page <= 1" (click)="pagina(pag.page - 1)">Anterior</button>
        <button type="button" class="od-btn od-btn-sm" [disabled]="pag.page >= totalPaginas(pag.total)" (click)="pagina(pag.page + 1)">Siguiente</button>
      </span>
    </div>
  </ng-container>
</ng-container>

<p class="od-note">Los comercios entran en Odoo con el rol «Comercio», nunca como proveedor. Los proveedores (por ejemplo, ekiipago) los registra Contabilidad directamente en Odoo.</p>
